import { render, staticRenderFns } from "./UploadOss.vue?vue&type=template&id=2f2b1dc6&"
import script from "./UploadOss.vue?vue&type=script&lang=js&"
export * from "./UploadOss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports